<template>
  <div :id="ident">
    <b-progress v-if="bar.value < 100" :value="bar.value" :variant="bar.variant" :key="bar.variant" show-progress></b-progress>
    <div v-html="data"></div>
  </div>
</template>

<script>
export default {
  name: 'webRequest',
  props:
      ['url', 'ident'],
  data () {
    return {
      data: '',
      contentLength: 0,
      bar: {
        value: 0,
        variant: 'success'
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      console.log('web-request: ' + this.url)
      //  timeout == 0 ==> no timeout
      let self = this
      this.$http.get(this.url, {
        timeout: 0,
        progress: function (event) {
          // console.log(event.loaded + '/' + event.total)
          let n = Number((100 * event.loaded) / event.total)
          // self.data = 'loading ' + n.toFixed(2) + '%'
          self.bar.value = n
        }
      }).then(response => {
        // this.data = reponse.data
        // this.data = reponse.status
        this.data = response.body
        this.contentLength = parseInt(response.headers.get('Content-Length'), 10)
        // this.data = reponse.text()
        // this.data = reponse.headers
        // this.data = reponse.headers.get('Content-Length')
        // this.data = reponse.headers.get('Date')
        console.log('web-request loaded ' + '(' + this.url + ') ' + this.contentLength + ' bytes')
      }, err => {
        console.log('web-request ' + this.url + ' FAILED ' + err)
        self.data = 'web-request failed - please retry'
        self.bar.variant = 'danger'
      })
    }
  },
  watch: {
    url (newVal, oldVal) {
      console.log('web-request ' + oldVal + ' ==> ' + newVal)
      this.getData()
    }
  }
}
</script>
